import React from 'react';

import { useIntl } from 'ha/i18n';
import { Typography } from '@hbf/dsl';
import { RenderDangerously } from 'ha/helpers/RenderDangerously';

export const OperatingHours: React.FC = () => {
  const { T } = useIntl();

  return (
    <Typography.Paragraph>
      <RenderDangerously renderWith="span">
        {T('Hours of operation')}
      </RenderDangerously>
    </Typography.Paragraph>
  );
};
